import React, { useEffect, useState } from 'react';
import { api } from '../../core/apiClient.ts';

export function AccountNotes({ id, notes, onSaved }: { id: string; notes: string; onSaved: (notes: string) => void }) {
  const [draft, setDraft] = useState(notes);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { setDraft(notes); }, [notes]);
  const save = async () => {
    setSaving(true); setError('');
    try {
      await api.put(`/api/ad-accounts/${encodeURIComponent(id)}/notes`, { notes: draft });
      onSaved(draft);
    } catch (err) { setError(err instanceof Error ? err.message : 'Не вдалося зберегти'); }
    finally { setSaving(false); }
  };
  return <div className="account-notes">
    <textarea className="input" rows={2} maxLength={5000} aria-label={`Примітки до кабінету ${id}`} placeholder="Додати примітку…" value={draft} disabled={saving} onChange={(event) => setDraft(event.target.value)} />
    {draft !== notes && <div className="account-notes__actions"><button className="btn btn--secondary btn--sm" disabled={saving} onClick={save}>{saving ? 'Збереження…' : 'Зберегти'}</button><button className="btn btn--ghost btn--sm" disabled={saving} onClick={() => { setDraft(notes); setError(''); }}>Скасувати</button></div>}
    {error && <span className="text-xs" role="alert">{error}</span>}
  </div>;
}
